// src/API/Config.js
const BASEURL = "https://apimiraclebaba.in";

export default BASEURL;